import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminNotesService } from './admin-notes.service';
import { TranscriptionCreateService } from '../transcription-create/transcription-create.service';
import { DashboardService } from '../dashboard/dashboard.service';
import * as moment from 'moment';
import * as global from '../global';
import { CommonService } from 'src/app/services/common.service';
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AdminDictationsService } from '../admin-dictations/admin-dictations.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { API_URL } from "../../../environments/api-url";
import { AuthService } from "../../services/auth.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { NoteEditorService } from "../note-editor/note-editor.service";
import { NoteAuditoryHistoryService } from "../note-auditory-history/note-auditory-history.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ViewNoteDialog } from '../transcription-create/view-note-dialog/view-note-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from '../census-patient-list/dialog-confirmation/dialog-confirmation.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FacilityService } from 'src/app/services/facility.service';
import { async } from '@angular/core/testing';

interface IFilter {
    active: boolean,
    creation_date: {
        startDate: any | Date | moment.Moment,
        endDate: any | Date | moment.Moment
    },
    date_of_service: {
        startDate: any | Date | moment.Moment,
        endDate: any | Date | moment.Moment
    },
    user: string,
    facility: string,
    patient: string,
    progress_status: string,
    isExportNotes: boolean
}
interface BReport {
    dos: string,
    provider: any[]
}
@Component({
    selector: 'app-admin-notes',
    templateUrl: './admin-notes.component.html',
    styleUrls: ['./admin-notes.component.css']
})
export class AdminNotesComponent implements OnInit {
    filteredFacilities: Observable<string[]>;
    facilityControl = new FormControl();
    filteredProvider: Observable<string[]>;
    providerControl = new FormControl();

    global = global;
    public isVisibleTable: boolean = true;
    isVisibleDetailTable: boolean = true;
    public dataSource: any;
    public sortedData: Array<any>;
    public notes: Array<any>;
    public group_notes: Array<any>;
    public notesGroup;
    public sortNotesGroup;
    public c_user;
    public c_date = moment(new Date());
    public creationDateFilter: Boolean = true;
    public serviceDateFilter: Boolean = true;
    displayedColumns: string[] = ['date_of_service', 'patient_name', 'facility_title', 'doctor_name', 'title', 'uploader_name', 'progress_status', 'stackholders', 'details'];

    @ViewChild(MatSort) sort: MatSort;

    provideModel: any = '';
    facilityMOdel: any = "";
    isAdminSide: boolean = false;
    company_id: any;
    filter: IFilter;
    appliedFilter: IFilter;
    users: Array<any> = [];
    providers: Array<any> = [];
    note_types: Array<any> = [];
    facilities: Array<any> = [];
    patients: Array<any> = [];
    uniqueProviders: any = [];
    status = [
        { title: 'Unsigned' },
        { title: 'Signed' },
        { title: 'Uploaded' }
    ];


    preDateRanges: any = {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    };

    currentDate = new Date();
    notesToShow = null;
    currentRouteUrl: any;
    currentUser: any;
    noteStatus: string = 'default';
    showPccLogo: boolean = false;
    isButtonDisable = true;
    selectedNotesSubscription: any;
    selectedNotes: any;
    selectedCompanySubscription: any;


    constructor(
        private _adminNotesService: AdminNotesService,
        private _transcriptionCreateService: TranscriptionCreateService,
        private _dashboardService: DashboardService,
        private _commonService: CommonService,
        private _dictationService: AdminDictationsService,
        private _authService: AuthService,
        private toastr: ToastrService,
        private loader: NgxUiLoaderService,
        private _router: Router,
        private httpclient: HttpClient,
        private noteEditorService: NoteEditorService,
        private auditoryService: NoteAuditoryHistoryService,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private facilityService: FacilityService,
    ) {
        this.currentUser = this._authService.currentUser;
        this.route.paramMap.subscribe((params: ParamMap) => {
            // this.resetTranscriptionMultiSelect.emit();
            this.currentRouteUrl = this._router.url.includes(';') ? this._router.url.split(';')[0] : this._router.url;

        });
    }

    ngOnInit() {
        this.selectedNotesSubscription = this._commonService.castSelectedNotesData.subscribe(notesData => {
            if (notesData) {
                this.selectedNotes = notesData;
            }
        });
        if(this.selectedNotes){
            this.setNotesToShow(this.selectedNotes)
        }
        this.filter = this.filterInitialState();

        if (window.location.pathname.includes('company')) {
            this.isAdminSide = true;
        }
        if (window.location.pathname.includes('company') && !window.location.pathname.includes('manage-companies')) {
            this.company_id = this.route.parent.parent.snapshot.params.id;
        }
        else if (window.location.pathname.includes('manage-companies')) {
            this.company_id = this.route.parent.parent.snapshot.params.id;
        }
        else if (this._authService.currentUser.user_type === global.USER_TYPE.BILLER) {
            this.selectedCompanySubscription = this._commonService.castSelectedCompany.subscribe(company_id => {
                if (company_id) {
                    this.company_id = company_id;
                    this.initNotes();
                    this.initProviders();
                    this.initCompanyFacilities();
                    this.initFacilities();
                } else {
                    this.company_id = this._authService.currentUser.company_id;
                }
            });
        }

        const isDOS = JSON.parse(localStorage.getItem('admin-notes:check_filter_dos'));
        if (isDOS) {
            this.filter.date_of_service = {
                startDate: moment(moment(isDOS.startDate).toLocaleString()),
                endDate: moment(moment(isDOS.endDate).toLocaleString()),
            };
        }

        const isProvider = JSON.parse(localStorage.getItem('admin-notes:provider_id_name'));
        if (isProvider) {
            this.provideModel = isProvider.name
            this.filter.user = isProvider.id
        }

        const isFacility = JSON.parse(localStorage.getItem('admin-notes:facility_id_title'));
        if (isFacility) {
            this.facilityMOdel = isFacility.title
            this.filter.facility = isFacility.id
        }

        const isStatus = JSON.parse(localStorage.getItem("admin-notes:select_status"))
        if (isStatus) {
            this.filter.progress_status = isStatus.status
            this.noteStatus = isStatus.value
        }

        this.appliedFilter = { ...this.filter };
        this.initNotes();
        this.initProviders();
        this.initCompanyFacilities();
        this.initFacilities();
        this.filteredProvider = this.providerControl.valueChanges.pipe(
            startWith(''),
            map((value: any) => this.filterProvider(value)));

        this.filteredFacilities = this.facilityControl.valueChanges.pipe(
            startWith(''),
            map((value: any) => this.filterFacilities(value)));

        if (this.currentUser.user_type === global.USER_TYPE.BILLER) {
            this.facilityMOdel = 'All';
        }
        this.setIsButttonDisable();
    }

    ngOnDestroy(): void {
        if (window.location.pathname.includes('note-editor')) {
            return;
        }
        this.removeFiltersFromStorage()
        if (!window.location.pathname.includes('noted-editor')) {
            this.selectedNotesSubscription.unsubscribe();
        }
        if(this.selectedCompanySubscription) {
            this.selectedCompanySubscription.unsubscribe();
        }
    }

    removeFiltersFromStorage() {
        localStorage.removeItem("admin-notes:check_filter_dos");
        localStorage.removeItem("admin-notes:provider_id_name");
        localStorage.removeItem("admin-notes:facility_id_title");
        localStorage.removeItem("admin-notes:select_status");
    }

    isPCCFacility(facility_id) {
        for (const facility of this.facilities) {
            if (facility_id === facility._id) {
                if (facility.pcc_facId) {
                    return true;
                }
            }
        }
    }
    private filterFacilities(value: string): string[] {
        if (value) {
            const filterValue = value.toLowerCase();
            if (value.length == 1) {
                this.showPccLogo = false;
            }
            return this.facilities.filter(option => option.title.toLowerCase().indexOf(filterValue) === 0);
        }
        else {
            return this.facilities;
        }
    }

    private filterProvider(value: string): string[] {
        if (value) {
            const filterValue = value.toLowerCase();
            let users = this.uniqueProviders.filter(option => option.name.toLowerCase().indexOf(filterValue) > -1);

            return this.sortFirstNameVise(users);
        }
        else {
            return this.sortFirstNameVise(this.uniqueProviders);
        }
    }

    sortFirstNameVise(arrayTosort) {
        let users = arrayTosort;
        let result = users.sort(function (a, b) {
            if (a.first_name?.toLowerCase() < b.first_name?.toLowerCase()) { return -1; }
            if (a.first_name?.toLowerCase() > b.first_name?.toLowerCase()) { return 1; }
            return 0;
        })
        return result;
    }


    initNotes() {
        this._adminNotesService.getNotes(null, this.filter, this.company_id).subscribe((response: any) => {
            if (response.status == 200) {
                this.notes = response.data;
                this.sortedData = this.notes;
                this.notesGroup = this.sortNotesByCreationDate(this.sortedData);
                this.dataSource = new MatTableDataSource(this.notesGroup);
            }
        });
    }

    setIsButttonDisable() {
        if (this.filter.date_of_service && this.provideModel && this.facilityMOdel) { 
            this.isButtonDisable = false;
        }
        else
            this.isButtonDisable = true;
    }

    exportNotes() {
        this.filter.isExportNotes = true;
        this._adminNotesService.getNotes(null, this.filter, this.company_id).subscribe((response: any) => {
            this.filter.isExportNotes = false;
            if (response.status == 200) {
                this.noteEditorService.downloadBatchNotes(response.data).subscribe((res: any) => {
                    if (res instanceof HttpResponse) {
                        this.filter.isExportNotes = false;
                        var url = window.URL.createObjectURL(res.body);
                        var a = document.createElement('a');
                        document.body.appendChild(a);
                        a.setAttribute('style', 'display: none');
                        a.href = url;
                        a.download = "All Notes";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                        this.toastr.success('Census notes has been downloaded successfully', "Success")
                    }
                })
            }
        });
               
    }

    sortNotesByCreationDate(notes) {
        var byDate = notes.slice(0);
        byDate.sort(function (a, b) {
            return Date.parse(a._id) < Date.parse(b._id) ? 1 : Date.parse(a._id) > Date.parse(b._id) ? -1 : 0;

        });
        return byDate;
    }
    getNotesDOS(note) {
        if (note && (note.date_obj || note.date_obj_str)) {
            let datee = note.date_obj_str ? note.date_obj_str : note.date_obj.year.toString() + '-' + note.date_obj.month.toString() + '-' + note.date_obj.day.toString();
            return moment(new Date(datee.replace(/-/g, "/"))).format('MMM DD, YYYY');
        }
        else if (note && note.filterServiceDate) {
            return moment(new Date(note.filterServiceDate.replace(/-/g, "/")).toLocaleString('en-US', { timeZone: note.timezone })).format('MMM DD, YYYY h:mm a');
        }
        else
            return ''
    }
    getNoteDOS(note) {
        if (note && (note.date_obj || note.date_obj_str)) {
            let datee = note.date_obj_str ? note.date_obj_str : note.date_obj.year.toString() + '-' + note.date_obj.month.toString() + '-' + note.date_obj.day.toString();
            return moment(new Date(datee.replace(/-/g, "/"))).format('MMM DD, YYYY');
        }
        else if (note && note.filterServiceDate) {
            return moment(new Date(note.filterServiceDate.replace(/-/g, "/")).toLocaleString('en-US', { timeZone: note.timezone })).format('MMM DD, YYYY');
        }
        else
            return ''
    }
    getNoteCreatedDate(note) {
        if (note && note.createdAt) {
            return moment(new Date(note.createdAt).toLocaleString('en-US', { timeZone: note.timezone })).format('MMM DD, YYYY');
        }
        else
            return ''
    }
    getNoteupdatedDate(note) {
        if (note && note.updatedAt) {
            return moment(new Date(note.updatedAt).toLocaleString('en-US', { timeZone: note.timezone })).format('MMM DD, YYYY');
        }
        else
            return ''
    }
    getServiceDate(note) {
        if (note && note.DOS) {
            return moment(new Date(note.DOS).toLocaleString('en-US', { timeZone: note.timezone })).format('MMM DD, YYYY h:mm a');
        }
        else {
            return ''
        }
    }
    resetFilter() {
        this.showPccLogo = false;
        this.facilityMOdel = '';
        this.provideModel = '';
        this.noteStatus = 'default';
        this.removeFiltersFromStorage();
        this.filter = this.filterInitialState();
        this.appliedFilter = { ...this.filter };
        this.filter.date_of_service = {
            startDate: moment().subtract(2, 'days'),
            endDate: moment(),
        };

        this.applyFilter();
        this.initCompanyFacilities();
        this.setIsButttonDisable();
    }

    clearProviderFilter() {
        this.provideModel = '';
        this.filter.user = '';
        this.initCompanyFacilities();
        this.setIsButttonDisable();
    }
    clearFacilityFilter() {
        this.showPccLogo = false;
        this.facilityMOdel = '';
        this.filter.facility = '';
        this.setIsButttonDisable();
    }

    initProviders() {
        this._dictationService.getProviders(this.company_id).subscribe((response: any) => {
            if (response.status == 200) {
                this.users = response.data.map(u => {
                    u.name = `${u.first_name} ${u.last_name}`;
                    if (u.user_type == '1') {
                        u.name += `, ${u.title}`
                    }
                    return u;
                });

                const map = new Map();
                for (const item of this.users) {
                    if (!map.has(item._id) && item.first_name) {
                        map.set(item._id, true);
                        this.uniqueProviders.push(item);
                    }
                }
                this.uniqueProviders = this.sortFirstNameVise(this.uniqueProviders);
            }
        });
    }
    sortProviders(a, b) {
        if (a.first_name < b.last_name) {
            return -1;
        }
        if (a.first_name > b.last_name) {
            return 1;
        }
        return 0;
    }
    onSelectProvider(item = null) {
        if (item) {
            this.provideModel = item.name;
            this.facilityMOdel = '';
            this.filter.facility = '';
            this.filter.user = item._id;
            this.initFacilities(item, null, this.company_id);
            const setProvider = {
                id: item._id,
                name: item.name
            }
            localStorage.setItem('admin-notes:provider_id_name', JSON.stringify(setProvider));
        }
        else {
            this.filter.user = null;
            this.provideModel = null;
            this.initFacilities();
        }
        this.setIsButttonDisable();
    }
    onSelectFacility(item = null) {
        if (item) {
            this.facilityMOdel = item.title;
            this.filter.facility = item._id;
            const setFacility = {
                id: item._id,
                title: item.title
            }
            localStorage.setItem('admin-notes:facility_id_title', JSON.stringify(setFacility));
            if (item.pcc_facId || item.source === 'PointClickCare') {
                this.showPccLogo = true;
            } else {
                this.showPccLogo = false;
            }
        }
        else {
            if (this.currentUser.user_type === global.USER_TYPE.BILLER) {
                this.facilityMOdel = 'All';
                this.filter.facility = null;
            } else {
                this.facilityMOdel = '';
                this.filter.facility = null;
            }
        }
    }
    getNoteById(note) {
        const noteData = this.noteEditorService.getNoteById(note.noteId, this.company_id).subscribe((response: any) => {
            if (response.status == 200) {
            }
            else if (response.status === 403) {
                this._router.navigate(['/403']);
            }

        })
    }
    getCurrentUser(user) {
        this.c_user = this._authService.currentUser.first_name + ' ' + this._authService.currentUser.last_name;
        if (this.c_user === user)
            return true;
        else
            return false;
    }
    getProvider(provider) {
        return provider.doctor_id_ref.first_name + ' ' + provider.doctor_id_ref.last_name;
    }
    resetProvider(provider) {
    }

    async initFacilities(provider = null, source = null, company_id = null) {
        let response: any = {};
        if (provider) {
            response = await this._transcriptionCreateService.getFacilities(provider._id, source, company_id).toPromise();
        }
        if (response.status === 200) {
            this.facilities = response.data.array;
            this.filteredFacilities = this.facilityControl.valueChanges.pipe(
                startWith(''),
                map((value: any) => this.filterFacilities(value))
            );
        }
    }

    filterInitialState(): IFilter {
        return {
            active: false,
            date_of_service: {
                startDate: moment().subtract(2, 'days'),
                endDate: moment(),
            },
            creation_date: null,
            user: '',
            facility: '',
            patient: '',
            progress_status: '',
            isExportNotes: false
        };

    }


    handleApplyFilterClick() {
        this.applyFilter();
        this.appliedFilter = { ...this.filter };
        this.setIsButttonDisable();  
    }

    applyFilter() {
        this.initNotes();
        return;
        this.sortedData = this.notes.filter(note => {
            if (this.filter.date_of_service && (this.filter.date_of_service.startDate && this.filter.date_of_service.endDate)) {
                const date = moment(new Date(note.date_of_service)).startOf('day');
                const startDate = moment(this.filter.date_of_service.startDate).startOf('day');
                const endDate = moment(this.filter.date_of_service.endDate).startOf('day');
                const dateResult = date.isBetween(startDate, endDate) || date.isSame(startDate) || date.isSame(endDate);

                return dateResult;
            }
            return true;
        }).filter(note => {
            if (this.filter.creation_date && (this.filter.creation_date.startDate && this.filter.creation_date.endDate)) {
                const date = moment(new Date(note.creation_date)).startOf('day');
                const startDate = moment(this.filter.creation_date.startDate).startOf('day');
                const endDate = moment(this.filter.creation_date.endDate).startOf('day');

                const dateResult = date.isBetween(startDate, endDate) || date.isSame(startDate) || date.isSame(endDate);

                return dateResult;
            }
            return true;
        }).filter(note => {
            if (this.filter.user) {
                return note.uploaded_by_id == this.filter.user;
            }
            return true;
        }).filter(note => {
            if (this.filter.facility) {
                return note.facility_id == this.filter.facility;
            }
            return true;
        }).filter(note => {
            switch (this.filter.progress_status) {
                case 'Uploaded':
                    return note.is_completed === 'true' && note.is_signed === 'true' && note.is_active === 'true';
                case 'Signed':
                    return note.is_signed === 'true' && note.is_completed !== 'true' && note.is_active === 'true';
                case 'Unsigned':
                    return note.is_signed !== 'true' && note.is_completed !== 'true' && note.is_active === 'true' && note.is_published === 'true';
                case 'Unpublished':
                    return note.is_signed !== 'true' && note.is_completed !== 'true' && note.is_active === 'true' && note.is_published !== 'true' || null;
                default:
                    return true;
            }
        });
    }

    sortData(sort: Sort, notesToShow) {
        const data = notesToShow.data.slice();
        if (!sort.active || sort.direction === '') {
            return;
        }

        notesToShow = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'title':
                    return compare(a.title, b.title, isAsc);
                case 'uploader_name':
                    return compare(a.uploader_name, b.uploader_name, isAsc);
                case 'date_of_time':
                    return compare(new Date(a.date_of_time).getTime(), new Date(b.date_of_time).getTime(), isAsc);
                case 'facility_title':
                    return compare(a.facility_title, b.facility_title, isAsc);
                case 'progress_status':
                    return compare(a.progress_status, b.progress_status, isAsc);
                case 'patient_name':
                    return compare(a.patient_id_ref?.first_name, b.patient_id_ref?.first_name, isAsc);
                default:
                    return 0;
            }
        });
        this.notesToShow.data = notesToShow;
    }
    getDate(date) {
        const formattedDate = date.replace(/-/g, '/');
        return moment(formattedDate).format('MMM DD, YYYY');
    }
    getStatus(status) {
        return this.auditoryService.formatOperation(status);
    }


    filterData() {
        const date_of_service = (this.appliedFilter.date_of_service && (this._commonService.dateRangeToString(moment(this.appliedFilter.date_of_service.startDate), moment(this.appliedFilter.date_of_service.endDate))) || '-');
        const date_of_submission = this.appliedFilter.creation_date && (this._commonService.dateRangeToString(moment(this.appliedFilter.creation_date.startDate), moment(this.appliedFilter.creation_date.endDate)) || '-');
        const user = this.appliedFilter.user ? this._commonService.getUserFullName(this.users.find(p => p._id === this.appliedFilter.user)) : '-';
        const facility = this.appliedFilter.facility ? this._commonService.getFacilityTitle(this.facilities.find(f => f._id === this.appliedFilter.facility)) : '-';
        const progress_status = this.appliedFilter.progress_status ? this.appliedFilter.progress_status : '-';
        var i = 0, j = 0;
        var total1 = 0;
        for (i = 0; i < this.notes?.length; i++)
            for (j = 0; j < this.notes[i].groupedData.length; j++)
                total1 = total1 + this.notes[i].groupedData[j].notedata.total;
        return [
            { label: 'Date of Service', value: date_of_service },
            { label: 'Creation Date', value: date_of_submission },
            { label: 'Provider', value: user },
            { label: 'Facility', value: facility },
            { label: 'Progress Status', value: progress_status },
            { label: 'Total', value: total1 },
        ];
    }

    getFacilityTitle(facility_id) {
        const f = this.notes.find(d => d.facility_id === facility_id);

        return f.facility_id_ref.title;
    }

    getUploaderName(uploaded_by_id) {
        const up = this.notes.find(d => {
            return d.uploaded_by_id === uploaded_by_id;
        });

        if (up?.uploaded_by_id_ref) {
            return up.uploaded_by_id_ref.first_name + ' ' + up.uploaded_by_id_ref.last_name;
        } else {
            return 'Uploader Name Not Found'
        }
    }

    getProviderName(doctor_id) {
        let note = { ...doctor_id };
        return note.groupedData.notedata.provider.first_name + ' ' + note.groupedData.notedata.provider.last_name;
    }

    setNotesToShow(notes: any) {
        this.notesToShow = Array.isArray(notes?.noteData) ? new MatTableDataSource(notes.noteData.map((note: any) => {
            const notes_data = {

                ...note,
                doctor_id_ref: notes.provider,
                facility_id_ref: notes.facility,
                uploaded_by_id_ref: notes.user,
                
            }

            return notes_data;
            
        }
        )) : null;
        notes === null ? this.isVisibleDetailTable = true : this.isVisibleDetailTable = false   
        this._commonService.setSelectedNotesData(notes);       
        
    }

    isNotesVisible() {
        return this.notesToShow !== null;
        
    }

    groupNotesByCreationDate(notes) {
        const notesByDateOfServiceGroups = {};
        for (let note of notes) {

            const doctor_id = note.doctor_id_ref?._id || note.doctor_id;
            const uploadedbyId = note.uploaded_by_id_ref?._id || note.uploaded_by_id;
            const momentDate = moment(new Date(note.filterCreationDate));
            const creationDate = momentDate.format('MMM DD, YYYY');
            if (!notesByDateOfServiceGroups[creationDate]) {
                notesByDateOfServiceGroups[creationDate] = {};
            }
            if (!notesByDateOfServiceGroups[creationDate][doctor_id]) {
                notesByDateOfServiceGroups[creationDate][doctor_id] = {};
            }
            if (!Array.isArray(notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id])) {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id] = [];
            }
            if (!Array.isArray(notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId])) {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId] = [];
            }
            // for unpublish
            if (!(Array.isArray(notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_active])) && note.is_signed !== 'true' && note.is_completed !== 'true' && note.is_active === 'true' && note.is_published !== 'true' || null) {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_active] = [];
            }
            //for unsigned
            if (!(Array.isArray(notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_signed])) && note.is_signed !== 'true' && note.is_completed !== 'true' && note.is_active === 'true' && note.is_published === 'true') {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_signed] = [];
            }
            //for signed
            if (!(Array.isArray(notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_published])) && note.is_signed === 'true' && note.is_completed !== 'true' && note.is_active === 'true') {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_published] = [];
            }
            //for completed
            if (!(Array.isArray(notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_completed])) && note.is_completed === 'true' && note.is_signed === 'true' && note.is_active === 'true') {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_completed] = [];
            }
            //
            // pushing unpublished
            if (note.is_signed !== 'true' && note.is_completed !== 'true' && note.is_active === 'true' && note.is_published !== 'true' || null) {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_active].push(note);
            }
            // pushing unsigned
            if (note.is_signed !== 'true' && note.is_completed !== 'true' && note.is_active === 'true' && note.is_published === 'true') {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_signed].push(note);
            }
            // pushing signed
            if (note.is_signed === 'true' && note.is_completed !== 'true' && note.is_active === 'true') {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_published].push(note);
            }
            // pushing completed
            if (note.is_signed === 'true' && note.is_completed === 'true' && note.is_active === 'true') {
                notesByDateOfServiceGroups[creationDate][doctor_id][note.facility_id][uploadedbyId][note.is_completed].push(note);
            }
        }
        return notesByDateOfServiceGroups;
    }
    changeCreationDate(event) {
        var startDate = moment(event.startDate);
        var endDate = moment(event.endDate);
        var noOfDays = endDate.diff(startDate, 'days');
        if (noOfDays > 30) {
            this.creationDateFilter = false;
            this.filter.creation_date.endDate = moment(this.filter.creation_date.startDate).add(29, "days").startOf('day');
            endDate = this.filter.creation_date.endDate;
            this.toastr.error('Can not select more than 30 days', 'ERROR');

            setTimeout(() => {
                this.creationDateFilter = true;
            }, 300)
        }
    }
    changeServiceDate(event) {
        if (event.startDate && event.endDate) {
            this.filter.date_of_service = {
                startDate: null,
                endDate: null
            }
            this.filter.date_of_service.startDate = event.startDate;
            this.filter.date_of_service.endDate = event.endDate;
            let startDate = moment(event.startDate);
            let endDate = moment(event.endDate);
            let changeDate = {
                startDate: event.startDate,
                endDate: event.endDate
            }
            localStorage.setItem('admin-notes:check_filter_dos', JSON.stringify(changeDate));
            let noOfDays = endDate.diff(startDate, 'days');
            if (noOfDays > 30) {
                this.serviceDateFilter = false;
                this.filter.date_of_service.endDate = moment(this.filter.date_of_service?.startDate).add(29, "days").startOf('day');
                endDate = this.filter.date_of_service.endDate;
                this.toastr.error('Can not select more than 30 days', 'ERROR');

                setTimeout(() => {
                    this.serviceDateFilter = true;
                }, 300)
            }
        }
    }


    getNoteStackholdersData(note) {
        const { uploaded_by_id_ref, qa, qa_e, doctor_id_ref } = note;

        if (doctor_id_ref) {
            doctor_id_ref.stackholder_type = 'P';
        }
        if (qa) {
            qa.stackholder_type = 'IQ';
        }
        if (qa_e) {
            qa_e.stackholder_type = 'EQ';
        }
        if (uploaded_by_id_ref) {
            if (uploaded_by_id_ref?.user_type === global.USER_TYPE.MEDICAL_ASSISTANT) {
                uploaded_by_id_ref.stackholder_type = 'MA';
            } else {
                uploaded_by_id_ref.stackholder_type = 'MT';
            }
        }
        const stackholders = [uploaded_by_id_ref, qa, qa_e, doctor_id_ref].filter(t => t?._id);
        const selectedStackholder = stackholders.find(t => t._id === note.note_status.id);
        return {
            stackholders,
            selectedStackholder
        }
    }

    handleStackHolderChange(event, note) {
        const stackholderId = event.value;
        note.note_status.id = stackholderId;
        const { qa, qa_e, doctor_id_ref } = note;

        if (stackholderId === qa._id) {
            note.note_status.status = 'internal_qa';
        } else if (stackholderId === qa_e._id) {
            note.note_status.status = 'external_qa'
        } else if (stackholderId === doctor_id_ref._id) {
            note.note_status.status = 'published'
        } else {
            note.note_status.status = 'in_progress'
        }
        this._adminNotesService.assignNoteManually(note.noteId, note.note_status)
            .subscribe((response: any) => {
                if (response.status === 200)
                    this.toastr.success(response.message, 'Success');
            }, () => {
                this.toastr.warning('Something went wrong please try again', 'Failure');
            })
    }

    goToNoteEditor(note) {
        if (this.checkVoidCensus(note.rounding_sheet_id)) {
            if (this._authService.currentUser.user_type === global.USER_TYPE.BILLER) {
                return this._router.navigate([`biller-note-editor/${note.noteId}`]);
            }
            else {
                return this._router.navigate([`company/${this.company_id}/note-editor/${note.noteId}`]);
            }
        } else {
            const dialogRef = this.dialog.open(ViewNoteDialog, {
                width: '80%',
                data: {
                    note_id: note.noteId,
                    timezone: 'America/New_York',
                    void_census: this.checkVoidCensus(note.rounding_sheet_id)
                }
            });
        }
    }

    totalCount(groupedData) {
        if (Array.isArray(groupedData)) {
            let totalCount = 0;
            for (let i = 0; i < groupedData.length; i++) {
                totalCount += groupedData[i]?.notedata?.total;
            }
            return totalCount;
        }
    }
    downloadReport(reportType = "grouped") {
        let allNotesData = [];
        if (reportType === "grouped") {
            this.notesGroup.forEach((gNotes) => {
                gNotes.groupedData.forEach((gData) => {
                    if (this.noteStatus !== "default") {
                        allNotesData.push({
                            "provider": gData.notedata?.provider?.first_name + " " + gData.notedata?.provider?.last_name,
                            "dos": this.getDate(gNotes._id),
                            "facility": gData.notedata?.facility?.title,
                            "total": gData.notedata?.total,
                            "status": this.getStatus(this.noteStatus),
                            "created_by": gData.notedata?.user?.first_name + " " + gData.notedata?.user?.last_name
                        });
                    } else {
                        allNotesData.push({
                            "provider": gData.notedata?.provider?.first_name + " " + gData.notedata?.provider?.last_name,
                            "dos": this.getDate(gNotes._id),
                            "facility": gData.notedata?.facility?.title,
                            "total": gData.notedata?.total,
                            "created_by": gData.notedata?.user?.first_name + " " + gData.notedata?.user?.last_name
                        });
                    }
                });
            });
            this._adminNotesService.exportGroupedReportAsXLSX(allNotesData).subscribe((response: any) => {
                if (response instanceof HttpResponse) {
                    var url = window.URL.createObjectURL(response.body);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = `Grouped Notes Report`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); 
                    this.toastr.success("Report Downloaded", "Success");
                }
            });
        } else {
            this.notesGroup.forEach((gNotes) => {
                gNotes.groupedData.forEach((gData) => {
                    gData.notedata.noteData.forEach((nData) => {
                        allNotesData.push({
                            "title": nData?.trans_title,
                            "facility": gData.notedata?.facility?.title,
                            "uploader": gData.notedata?.user?.first_name + " " + gData.notedata?.user?.last_name,
                            "provider": gData.notedata?.provider?.first_name + " " + gData.notedata?.provider?.last_name,
                            "dos": this.getNoteDOS(nData),
                            "status": this.getStatus(nData?.note_status?.status),
                            "created_at": this.getNoteCreatedDate(nData),
                            "updated_at": this.getNoteupdatedDate(nData),
                            "patient": nData.patient_id_ref?.first_name + ' ' + nData.patient_id_ref?.last_name
                        });
                    });
                });
            });
            this._adminNotesService.exportFullReportAsXLSX(allNotesData).subscribe((response: any) => {
                if (response instanceof HttpResponse) {
                    var url = window.URL.createObjectURL(response.body);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = `All Notes Report`;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                    this.toastr.success("Report Downloaded", "Success");
                }
            });
        }
    }
    checkVoidCensus(patientRoundingSheet) {
        if (patientRoundingSheet) {
            if (patientRoundingSheet?.is_void) {
                if (patientRoundingSheet.is_void === true) return false;
                else return true;
            } else {
                return true
            }
        } else {
            return true;
        }
    }
    onSelectStatus(item = null) {
        if (item == 'signed' || item == 'uploaded' || item == 'not_uploaded' || item == 'published') {
            this.filter.progress_status = item;

            const setStatus = {
                status: this.filter.progress_status,
                value: this.noteStatus
            }
            localStorage.setItem('admin-notes:select_status', JSON.stringify(setStatus));

        }
        else {
            this.noteStatus = 'default';
            delete this.filter?.progress_status;
        }
    }
    async deleteNote(selectedNote) {
        let dialogRef = this.dialog.open(DialogConfirmationComponent, {
            data: {
                message: "Are you sure you want to delete this Progress Note?"
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
            if (result === "true") {
                const infoToast = this.toastr.info('Deleting Note..', 'Please wait')
                let details = {
                    transcribtion_id: selectedNote.noteId,
                    is_active: "false",
                    is_trashed: "true",
                    note_active_status: "trashed"
                };
                let response: any = await this._transcriptionCreateService.deleteTranscription(details, "").toPromise();

                if (response.status) {
                    await this.initNotes();

                    this.notesToShow.data = this.notesToShow.data.filter((note) => note.patient_id_ref._id !== response.data.patient_id)

                    this.toastr.success("Note Deleted Successfully", "Success");
                } else {
                    this.toastr.clear(infoToast.toastId);
                }
            }
        });
    }
    async downloadBatchReport() {
        this.toastr.info('Downloading Batch Notes Report', 'Downloading...');
        let batchReportDetails: Array<BReport> = [];
        this.notesGroup.forEach((gNotes) => {
            const report = {} as BReport;
            report.dos = this.getDate(gNotes._id);
            report.provider = [];
            gNotes.groupedData.forEach((gData) => {
                let index = report.provider.findIndex((p) => p.name === (gData.notedata?.provider?.first_name + " " + gData.notedata?.provider?.last_name));
                if (index > -1) {
                    report.provider[index].noteIds.push(...gData.notedata.noteData.map(n => n.noteId));
                } else {
                    report.provider.push({
                        'name': gData.notedata?.provider?.first_name + " " + gData.notedata?.provider?.last_name,
                        'noteIds': gData.notedata.noteData.map(n => n.noteId)
                    })
                }
            });
            batchReportDetails.push(report);
        });
        await this._adminNotesService.generateBatchNotesPDF(batchReportDetails).subscribe((res) => {
            if (res instanceof HttpResponse) {
                var url = window.URL.createObjectURL(res.body);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none');
                a.href = url;
                a.download = "Batch Report";
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
                this.toastr.success('Batch Report Downloaded', 'Success');
            } else {

            }
        }, (err) => {
            this.toastr.error('Something went wrong while downloading batch report', 'Failed');
        },
            () => {
            });
    }

    async initCompanyFacilities() {
        const company_id = this.company_id;

        const filter: any = {
            is_active: true,
            company_id,
            source: 'all',
            trueRcmStatus: 'all'
        };

        const projection = {
            'title': 1,
            'address': 1,
            'city': 1,
            'state': 1,
            'zip_code': 1,
            'provider_ids_ref': 1,
        }
        let result: any = await this.facilityService.getAllFacilitiesProviderTemplateAssoc(filter, projection).toPromise();
        if (result.status == 200) {
            this.facilities = result.data.facilities;
            this.filteredFacilities = this.facilityControl.valueChanges.pipe(
                startWith(''),
                map((value: any) => this.filterFacilities(value))
            );
        }
        else {
        }
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

